import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AppConfig } from '../../../../config/routes.config';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedBookingAccessHelperService } from '../../services/shared-booking-access-helper.service';
import { AuthService } from '../../../../core/auth/auth.service';
import moment from 'moment';
import { ShareDto } from 'src/app/api/models';
import { UserBookingsApiService } from 'src/app/api/services';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { AlertType } from 'src/shared/models/enums';
import { IonNav, ModalController } from '@ionic/angular/standalone';
import { AddSharedBookingAccessPage } from '../add-shared-booking-access/add-shared-booking-access.page';
import { AlertService } from '@v-locker-app/v-locker-common';
import { SharedAccessLogsPage } from '../shared-access-logs/shared-access-logs.page';
import { BookingAccessInfoComponent } from "../../components/booking-access-info/booking-access-info.component";
import { IconComponent } from "../../../../../shared/components/elements/icon/icon.component";
import { IonList, IonItemSliding, IonItem, IonItemOptions, IonItemOption, IonButton } from "@ionic/angular/standalone";
import { BookingAccessItemComponent } from "./components/booking-access-item/booking-access-item.component";
import { TranslatePipe } from '@ngx-translate/core';
import { NgFor, NgIf } from '@angular/common';

@Component({
	selector: 'vl-shared-bookings-access-list',
	templateUrl: './shared-bookings-access-list.page.html',
	styleUrls: ['./shared-bookings-access-list.page.scss'],
 imports: [IonButton, IonItemOption, IonItemOptions, NgIf, IonItem, IonItemSliding, NgFor, IonList, BookingAccessInfoComponent, IconComponent, BookingAccessItemComponent, TranslatePipe],
})
export class SharedBookingsAccessListPage implements OnInit {
	routes = AppConfig.routes;
	sharedAccess: Array<ShareDto> = [];
	bookingId;
	towerGroupName = '';

	constructor(private loader: CustomSpinnerService,
				private bookingService: UserBookingsApiService,
				private activatedRoute: ActivatedRoute,
				private modalController: ModalController,
				private ionNav: IonNav,
				private router: Router,
				private cd: ChangeDetectorRef,
				private sharedAccessHelpService: SharedBookingAccessHelperService,
				private authHelpService: AuthService,
				private alertService: AlertService) {
	}

	ngOnInit() {
		this.bookingId = this.sharedAccessHelpService.booking.id;
		if(this.bookingId) this.loader.show().then(() => { this.getSharedBookings(); });
	}

	async close() {
		await this.modalController.dismiss();
	}

	doRefresh(event) {
		this.sharedAccess = [];
		this.getSharedBookings(event);
	}

	completeRefresh(e) {
		e.target.complete();
	}

	askRevokeAccess(ba: ShareDto, ionSlide) {
		this.alertService.twoButtonsAlert(() => {
			this.loader.show().then(() => {
				this.revokeAccess(ba.id, ionSlide)
			});
		}, () => {

		}, AlertType.RevokeAccess);
	}

	revokeAccess(id, ionSlide) {
		this.bookingService.deleteShare({
			id: this.bookingId,
			shareId: id
		}).subscribe(() => {
			// this.analyticsService.logEvent(AnalyticsEvents.StopShare, {
			// 	bookingId: this.bookingId,
			// 	shareId: id
			// });
			ionSlide.close().then(() => {
				setTimeout(() => {
					this.getSharedBookings();
				}, 100)
			});
		})
	}

	openLogs(ba: ShareDto, ionSlide) {
		this.ionNav.push(SharedAccessLogsPage, {bookingId: this.bookingId, shareId: ba.id});
		ionSlide.close();
	}

	async openItem(share: ShareDto) {
		if (share.status === 'INVITED' || share.status === 'ACCEPTED') {
			await this.ionNav.push(AddSharedBookingAccessPage, { bookingId: this.bookingId, shareId: share.id});
		}
	}

	getSharedBookings(event = null) {
		this.bookingService.getBookingShares({
			id: this.bookingId
		}).subscribe(r => {
			if (r.length !== 0) {
				let booking = r[0].booking;
				this.sharedAccessHelpService.setInfoData(booking);
			}
			this.sharedAccess = [...r.sort((a, b) => +moment(b.startDate).format('X') - +moment(a.startDate).format('X'))];
			this.cd.detectChanges();

			if (event) {
				this.completeRefresh(event);
			} else {
				this.loader.hide();
			}
		})
	}

	identify(index, item) {
		return item.id;
	}

	checkAddNew() {
		this.authHelpService.checkVerification(
			async () => {
				await this.ionNav.push(AddSharedBookingAccessPage, { bookingId: this.bookingId});
			},
			() => {
				this.alertService.emailPhoneNotVerified(() => {
					this.close().then(() => {
						this.router.navigate([this.routes.settings.fullPath]);
					})},
					() => {
					});
			});
	}
}
